import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

export default function ({ app, store }) {
  Sentry.init({
    Vue,
    dsn: 'https://86dbf4599bcedfe01ed388d6a86d9f56@apm.xp-pen.com/4',
    environment: process.env.NODE_ENV,
    release: process.env.SENTRY_RELEASE,
    sampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(app.router),
        tracingOrigins: ['community.xp-pen.com', 'xfanstest.xp-pen.com', /^\//],
      }),
    ],
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    logErrors: true,
  })

  // Set user context if available
  if (store?.state?.userInfo?.uid) {
    Sentry.setUser({ id: store.state.userInfo.uid })
  }
}
